import React from "react";
import logo from "../../Logo/ramakids logo.png";
import { Link, useLocation } from "react-router-dom";
import "./navbar.css";

const Navbar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <div className="navbar navbar-inverse fixingnavbar">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-2 col-sm-2">
              <div className="navbar-header text-center">
                <button
                  type="button"
                  className="navbar-toggle"
                  data-toggle="collapse"
                  data-target=".navbar-collapse"
                >
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
                <Link
                  style={{
                    display: "flex",
                    justifyContent: "flexStart",
                    alignItems: "center",
                    marginLeft: "11%",
                    height: "6rem",
                  }}
                  to="/"
                >
                  <img src={logo} alt="Ramakrishna Website" id="navbarImage" />
                </Link>
              </div>
            </div>
            <div className="col-md-10 col-sm-10">
              <div className="navbar-collapse collapse">
                <ul className="nav navbar-nav pull-right mainNav">
                  <li className={isActive("/") ? "active" : ""}>
                    <Link to="/" className="adjustPadding">
                      Home
                    </Link>
                  </li>

                  {/* Campus Menu */}
                  <li className="dropdown">
                    <Link
                      to="#"
                      className={`dropdown-toggle ${
                        isActive("/aboutCampus") ||
                        isActive("/facilities") ||
                        isActive("/schoolTour")
                          ? "active"
                          : ""
                      } adjustPadding`}
                      data-toggle="dropdown"
                    >
                      Campus <b className="caret"></b>
                    </Link>
                    <ul
                      className="dropdown-menu adjustPadding"
                      style={{ backgroundColor: "rgb(255 204 0)" }}
                    >
                      <li>
                        <Link to="/aboutCampus" className="customeUl">
                          About Campus
                        </Link>
                      </li>
                      <li>
                        <Link to="/facilities" className="customeUl">
                          Facilities
                        </Link>
                      </li>
                      <li>
                        <Link to="/schoolTour" className="customeUl">
                          School Tour
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Admission Menu */}
                  <li className="dropdown">
                    <Link
                      to="#"
                      className={`dropdown-toggle ${
                        isActive("/admissionProcess") ||
                        isActive("/admissionForm")
                          ? "active"
                          : ""
                      } adjustPadding`}
                      data-toggle="dropdown"
                    >
                      Admission <b className="caret"></b>
                    </Link>
                    <ul
                      className="dropdown-menu"
                      style={{ backgroundColor: "rgb(255 204 0)" }}
                    >
                      <li>
                        <Link to="/admissionProcess" className="customeUl">
                          Admission Process
                        </Link>
                      </li>
                      <li>
                        <Link to="/admissionForm" className="customeUl">
                          Admission Form
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Academics Menu */}
                  <li className="dropdown">
                    <Link
                      to="#"
                      className={`dropdown-toggle ${
                        isActive("/curriculamdetails") ? "active" : ""
                      } adjustPadding`}
                      data-toggle="dropdown"
                    >
                      Academics <b className="caret"></b>
                    </Link>
                    <ul
                      className="dropdown-menu"
                      style={{ backgroundColor: "rgb(255 204 0)" }}
                    >
                      <li>
                        <Link to="/curriculamdetails" className="customeUl">
                          Curriculum Details
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Activities Menu */}
                  <li className="dropdown">
                    <Link
                      to="#"
                      className={`dropdown-toggle ${
                        isActive("/newsEvents") || isActive("/coCurricular")
                          ? "active"
                          : ""
                      } adjustPadding`}
                      data-toggle="dropdown"
                    >
                      Activities <b className="caret"></b>
                    </Link>
                    <ul
                      className="dropdown-menu"
                      style={{ backgroundColor: "rgb(255 204 0)" }}
                    >
                      <li>
                        <Link to="/newsEvents" className="customeUl">
                          Newsletters
                        </Link>
                      </li>
                      <li>
                        <Link to="/coCurricular" className="customeUl">
                          Co-Curricular Initiatives
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Parent Zone Menu */}
                  <li className="dropdown">
                    <Link
                      to="#"
                      className={`dropdown-toggle ${
                        isActive("/circular") ? "active" : ""
                      } adjustPadding`}
                      data-toggle="dropdown"
                    >
                      Parent Zone <b className="caret"></b>
                    </Link>
                    <ul
                      className="dropdown-menu"
                      style={{ backgroundColor: "rgb(255 204 0)" }}
                    >
                      <li>
                        <Link to="/circular" className="customeUl">
                          Circular
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Additional Menus */}
                  <li>
                    <Link to="/gallery" className="adjustPadding">
                      Gallery
                    </Link>
                  </li>
                  <li>
                    <Link to="/disclosure" className="adjustPadding">
                      Public Disclosure
                    </Link>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle adjustPadding"
                      data-toggle="dropdown"
                    >
                      Contact <b className="caret"></b>
                    </Link>
                    <ul
                      className="dropdown-menu"
                      style={{ backgroundColor: "rgb(255 204 0)" }}
                    >
                      <li>
                        <Link className="customeUl" to="/contact1">
                          Contact Us
                        </Link>
                      </li>
                      <li>
                        <Link className="customeUl" to="/referAfriend">
                          Refer To Friend
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Outlet Component */}
      {/* <Outlet /> */}
    </>
  );
};

export default Navbar;
